import React from 'react';
import bannerImg from './banner.png';
// import styles from './index.module.scss';

function LoginLeftContent() {
  return (
    <div
      style={{
        width: '300px',
        height: '100%',
        margin: 0,
      }}
    >
      <img
        src={bannerImg.src}
        style={{
          margin: 0,
          width: '300px',
          height: '100%',
          objectFit: 'fill',
          borderRadius: '0px',
        }}
        alt=""
      />
    </div>
  );
}

export default LoginLeftContent;
